import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vikhrolitopunecab() {



const cardData = {
  keyword: " Vikhroli to Pune Cab Services",

headingDescription: "Velocity Cab provides reliable and comfortable Vikhroli to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Vikhroli to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Vikhroli to Pune cab travel.",

topPlaces: [

  {
    title: "Parvati Hill",
    description: "Parvati Hill is a historic landmark in Pune offering panoramic views of the city from its hilltop temples. Travelers can climb the steps to explore ancient shrines and enjoy a peaceful environment surrounded by natural beauty."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a beautifully designed Japanese-style garden featuring serene landscapes, water streams, and walking paths. It is a perfect place for relaxation, photography, and nature walks."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. Its peaceful surroundings and historic architecture make it a unique spiritual and heritage site in Pune."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gates, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
    {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is one of Pune’s most important historical landmarks, known for its role in India’s freedom movement. Travelers booking a sedan cab in Pune can explore its elegant architecture, peaceful gardens, and museum dedicated to Mahatma Gandhi, making it a must-visit cultural and heritage site."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is a famous spiritual destination in Pune dedicated to Lord Ganesha. Visitors can experience divine blessings, admire the beautifully decorated idol, and enjoy the vibrant atmosphere, especially during Ganesh Chaturthi celebrations."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases an extensive collection of Indian artifacts, including sculptures, musical instruments, and traditional objects. It offers visitors a deep insight into India’s cultural heritage and artistic excellence."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular garden in Pune known for its lush greenery and the Siddhivinayak Temple located inside it. It is a peaceful spot for families, morning walkers, and visitors looking for relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a scenic riverside park offering boating facilities, green lawns, and walking tracks. It is a great place for relaxation and leisure activities in the heart of Pune."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a major shopping and entertainment hub featuring top brands, restaurants, cinemas, and entertainment zones. It is a popular destination for shopping and leisure activities."
  }
],



services: [
{
name: "Vikhroli to Pune Cab",
description: "Vikhroli to Pune cab service offers reliable and comfortable intercity transportation between Vikhroli in Mumbai and Pune city. Travelers can enjoy smooth travel via the Mumbai–Pune Expressway in well-maintained vehicles such as sedan, Ertiga, and Innova Crysta. Professional drivers provide timely pickups from Vikhroli East, Vikhroli West, residential societies, offices, and commercial areas. This service is widely used by corporate professionals, families, and tourists traveling between Mumbai and Pune. Spacious air-conditioned vehicles ensure a relaxed long-distance journey. Online cab booking provides instant confirmation, transparent pricing, and flexible pickup options for a hassle-free travel experience."
},
{
name: "Vikhroli to Pune One Way Cab",
description: "Vikhroli to Pune one way cab service provides economical transportation for passengers traveling from Mumbai to Pune without paying for return fares. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova for smooth expressway travel. Professional drivers ensure punctual pickups and safe driving throughout the journey. This service is ideal for business trips, airport transfers, and personal travel. Air-conditioned vehicles and spacious seating ensure comfortable long-distance journeys."
},
{
name: "Vikhroli to Pune Station Cab",
description: "Vikhroli to Pune station cab service offers convenient transportation for passengers traveling to Pune Railway Station. Travelers can book reliable taxis with professional drivers ensuring timely pickups and smooth highway travel. Vehicles such as sedan, Ertiga, and Innova are available based on comfort preferences. This service is ideal for passengers connecting train journeys with intercity cab travel."
},
{
name: "Vikhroli to Pimpri Chinchwad Cab",
description: "Vikhroli to Pimpri Chinchwad cab service provides dependable transportation between Mumbai and the PCMC region of Pune. Travelers can enjoy comfortable rides in vehicles such as sedan, Ertiga, and Innova. Professional drivers ensure safe expressway travel and punctual pickups from Vikhroli locations. This service is widely used by corporate travelers visiting industrial and IT hubs in Pimpri Chinchwad."
},
{
name: "Vikhroli to Wanwadi Cab",
description: "Vikhroli to Wanwadi cab service offers reliable transportation between Vikhroli in Mumbai and Wanwadi in Pune. Travelers can book comfortable vehicles for smooth highway travel. Professional drivers provide punctual pickups and safe driving. This service is ideal for corporate travelers, families, and tourists visiting Wanwadi and nearby areas."
},
{
name: "Vikhroli to Pune Innova Crysta Cab",
description: "Vikhroli to Pune Innova Crysta cab service provides premium SUV transportation for travelers seeking luxury and comfort. The Toyota Innova Crysta offers spacious seating, excellent suspension, and smooth highway performance. Professional drivers provide safe driving and punctual pickups from homes, offices, and hotels across Vikhroli. This service is ideal for corporate travel, family trips, and group journeys."
},
{
name: "Vikhroli to Pune 7 Seater Cab",
description: "Vikhroli to Pune 7 seater cab service offers spacious SUV travel for families and small groups. Vehicles like Ertiga provide comfortable seating, air-conditioning, and smooth highway travel. Professional drivers ensure safe driving and punctual pickups from Vikhroli. This service is perfect for group travel and family trips."
},
{
name: "Vikhroli to Pune Sedan Cab",
description: "Vikhroli to Pune sedan cab service offers economical transportation using vehicles such as Swift Dzire, Etios, and Hyundai Xcent. These cars are ideal for individuals and small families traveling between Mumbai and Pune. Professional drivers ensure punctual pickups and smooth expressway travel. Air-conditioned vehicles ensure comfortable long-distance journeys."
},
{
name: "Vikhroli to Pune Shivaji Nagar Cab",
description: "Vikhroli to Shivaji Nagar cab service provides reliable intercity transportation between Vikhroli in Mumbai and Shivaji Nagar in Pune. Travelers can enjoy comfortable rides in air-conditioned vehicles with professional drivers ensuring safe highway travel. This service is widely used by business travelers, students, and tourists visiting central Pune."
},
{
name: "Vikhroli to Swargate Cab",
description: "Vikhroli to Swargate cab service offers dependable transportation between Vikhroli and Swargate in Pune. Travelers can book comfortable vehicles with professional drivers ensuring safe and smooth expressway travel. This service is ideal for passengers traveling to central Pune bus terminal areas."
},
{
name: "Taxi Service in Vikhroli Mumbai",
description: "Taxi service in Vikhroli Mumbai provides reliable transportation for local travel, airport transfers, and outstation journeys. Travelers can book comfortable vehicles with experienced drivers for safe travel across Mumbai and nearby cities including Pune."
},
{
name: "Vikhroli to Viman Nagar Taxi Service",
description: "Vikhroli to Viman Nagar taxi service provides convenient transportation between Vikhroli in Mumbai and Viman Nagar in Pune. Travelers can enjoy comfortable rides in vehicles such as sedan, Ertiga, and Innova. Professional drivers provide punctual pickups and smooth highway travel. This service is commonly used by airport passengers and corporate travelers."
},
{
name: "Vikhroli Cabs Service",
description: "Vikhroli cab service offers reliable transportation for city travel and outstation journeys. Travelers can book comfortable vehicles with professional drivers for safe and convenient travel across Mumbai and nearby destinations including Pune."
},
{
name: "Outstation Cabs Taxi Service Mumbai",
description: "Outstation cabs taxi service in Mumbai provides long-distance transportation from Mumbai to cities such as Pune, Nashik, and Lonavala. Travelers can choose comfortable vehicles with experienced drivers for safe and smooth travel."
},
{
name: "Vikhroli to Pune Taxi",
description: "Vikhroli to Pune taxi service provides convenient transportation between Mumbai and Pune with comfortable vehicles and experienced drivers ensuring smooth highway journeys."
},
{
name: "Vikhroli to Pune Cab Service",
description: "Vikhroli to Pune cab service offers dependable intercity travel with comfortable vehicles and professional drivers ensuring safe journeys."
},
{
name: "Vikhroli to Pune Taxi Booking",
description: "Vikhroli to Pune taxi booking allows passengers to easily reserve taxis online with instant confirmation and transparent pricing."
},
{
name: "Vikhroli to Pune Drop Taxi",
description: "Vikhroli to Pune drop taxi service offers convenient one-way transportation between Mumbai and Pune with comfortable vehicles and affordable fares."
},
{
name: "Vikhroli to Pune Online Cab Booking",
description: "Vikhroli to Pune online cab booking allows travelers to reserve taxis instantly through websites or mobile platforms for convenient intercity travel."
},
{
name: "Vikhroli to Pune Private Cab",
description: "Vikhroli to Pune private cab service provides exclusive transportation for passengers seeking privacy and flexible pickup timing during their journey."
},
{
name: "Vikhroli to Pune Outstation Cab",
description: "Vikhroli to Pune outstation cab service provides dependable long-distance transportation with experienced drivers and comfortable vehicles."
},
{
name: "Vikhroli to Pune Cheap Cab",
description: "Vikhroli to Pune cheap cab service offers budget-friendly transportation for travelers seeking economical intercity travel options."
}
],

tableData: [
["Vikhroli to Pune Cab","Vikhroli to Pune One Way Cab"],
["Vikhroli to Pune Station Cab","Vikhroli to Pimpri Chinchwad Cab"],
["Vikhroli to Wanwadi Cab","Vikhroli to Pune Innova Crysta Cab"],
["Vikhroli to Pune 7 Seater Cab","Vikhroli to Pune Sedan Cab"],
["Vikhroli to Pune Shivaji Nagar Cab","Vikhroli to Swargate Cab"],
["Taxi Service in Vikhroli Mumbai","Vikhroli to Viman Nagar Taxi Service"],
["Vikhroli Cabs Service","Outstation Cabs Taxi Service Mumbai"],
["Vikhroli to Pune Taxi","Vikhroli to Pune Cab Service"],
["Vikhroli to Pune Taxi Booking","Vikhroli to Pune Drop Taxi"],
["Vikhroli to Pune Online Cab Booking","Vikhroli to Pune Private Cab"],
["Vikhroli to Pune Outstation Cab","Vikhroli to Pune Cheap Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Vikhroli to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Vikhroli to Pune cab service bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Vikhroli to Pune cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, business travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Vikhroli to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Vikhroli",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Vikhroli including Vikhroli East, Vikhroli West, and nearby locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Vikhroli to Pune cab service bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Vikhroli to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Vikhroli to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Vikhroli from Pune?", answer: "The road distance between Vikhroli and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Vikhroli to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Vikhroli to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Vikhroli to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Vikhroli and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Vikhroli." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Vikhroli to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket Sawant",
    feedback:
      "Vikhroli to Pune cab service with Velocity Cab was very comfortable and smooth. The vehicle was clean, and the long journey felt safe and well-managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shruti Patil",
    feedback:
      "The Vikhroli to Pune cab ride with Velocity Cab was excellent. The driver was punctual and professional, making the trip hassle-free and enjoyable.",
    rating: 5
  }
];
































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vikhroli to Pune Cab Service | Velocity Cabs",
  "description": "Book Vikhroli to Pune cab with Velocity Cabs. One way, round trip, and airport transfer cabs available including Innova, Innova Crysta, Ertiga, and Sedan. Safe, reliable, and affordable taxi service from Vikhroli, Mumbai to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1850"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Vikhroli to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta
    name="description"
    content="Book Vikhroli to Pune cab with Velocity Cabs. One way & round trip cabs including Innova, Innova Crysta, Ertiga & Sedan for airport transfers, corporate trips & city travel."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vikhrolitopunecab;